import { render, staticRenderFns } from "./PaymentStats.vue?vue&type=template&id=21fdb778"
import script from "./PaymentStats.vue?vue&type=script&lang=js"
export * from "./PaymentStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports